import React, { SetStateAction, useState as classicUseState } from 'react';
import { CSSTransition } from 'react-transition-group';
import { ClickAwayListener } from '@material-ui/core';
import { ReactComponent as MenuImage } from '@assets/svg/more.svg';

import { IPicture } from '@models/Picture.model';
import { MenuContent } from './components';

import { Container, Block, ContainerSidebar } from './Menu.styles';

interface IMenu {
  picture: IPicture | undefined;
  setSelectedPicture: React.Dispatch<React.SetStateAction<string>>;
  setShow: React.Dispatch<SetStateAction<boolean>>;
  selectedPicture: string;
  data: IPicture[];
}

const Menu = ({
  picture,
  selectedPicture,
  data,
  setSelectedPicture,
  setShow,
}: IMenu) => {
  const [open, setOpen] = classicUseState(false);
  const handleClickAway = () => {
    if (open) setOpen(false);
  };
  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <Container>
        <ContainerSidebar onClick={() => setOpen(!open)}>
          <MenuImage />
        </ContainerSidebar>

        <CSSTransition
          in={open}
          timeout={300}
          classNames="my-node"
          unmountOnExit
          onEnter={() => setOpen(true)}
          onExited={() => setOpen(false)}
        >
          <Block>
            <MenuContent
              selectedPicture={selectedPicture}
              picture={picture}
              data={data}
              setSelectedPicture={setSelectedPicture}
              setOpenMenu={setOpen}
              setShow={setShow}
            />
          </Block>
        </CSSTransition>
      </Container>
    </ClickAwayListener>
  );
};

export { Menu };
